module.exports = __webpack_public_path__ + "media/images/earth-topology-739e278bf846bb7b50d5f8918762840c.png";